export const HANDLE_RESPONSE_PROTECTION_PRODUCTS =
  'feature/protectionProducts/HANDLE_RESPONSE_PROTECTION_PRODUCTS';
export const HANDLE_LOADING_PROTECTION_PRODUCTS =
  'feature/protectionProducts/HANDLE_LOADING_PROTECTION_PRODUCTS';
export const HANDLE_ERROR_PROTECTION_PRODUCTS =
  'feature/protectionProducts/HANDLE_ERROR_PROTECTION_PRODUCTS';
export const SET_FORM_STATE = 'feature/protectionProducts/SET_FORM_STATE';
export const RESET_PROTECTION_PRODUCTS =
  'feature/protectionProducts/RESET_PROTECTION_PRODUCTS';
